import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../components/toaster/Toaster";
import { useSelector } from "react-redux";
import InvoiceServices from "../../services/Invoice";
import { useReactToPrint } from "react-to-print";
import InvoiceGeneralFormat from "../components/InvoiceFormats/general-format";
import InvoiceSeppicFormate from "../components/InvoiceFormats/seppic-formate";
import InvoiceAabFormate from "../components/InvoiceFormats/aab-formate";

const InvoicePreview = () => {

  const invoiceRef = useRef(null);
  const { id } = useParams();
  const { userData } = useSelector((state) => ({ userData: state.user_detail }));

  const [loading, setLoading] = useState(false);
  const [invoice, setInvoice] = useState();

  const handleGeneratePdf = useReactToPrint({
    contentRef: invoiceRef,
    documentTitle: `invoice_${invoice?.fbr_invoice_number}`,
    onBeforePrint: () => { setLoading(true); return Promise.resolve(); },
    onAfterPrint: () => setLoading(false),
  });

  const getInvoiceDetails = async () => {
    try {
      const { data } = await InvoiceServices.getInvoiceById(id);
      setInvoice(data);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    if (id) getInvoiceDetails();
  }, [id]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header d-flex align-items-center justify-content-between">
          <div className="page-title">
            <h4>View Sale Invoice</h4>
          </div>
          <div className="d-flex align-items-center">
            <button disabled={loading} className="btn btn-added" onClick={() => handleGeneratePdf()}>
              <PlusCircle className="me-2 iconsize" />
              {loading ? 'Printing...' : 'Print'}
            </button>
          </div>
        </div>

        <div className="card-body mb-3" style={{ transform: 'scale(0.93)', transformOrigin: 'top left' }}>
          <div ref={invoiceRef} className="card m-auto" style={{ width: '1123px', minHeight: '700px', border: 'none', position: 'relative' }}>
            {userData?.id == 7 ? (
              <InvoiceSeppicFormate invoice={invoice} />
            ) : userData?.id === 14 ? (
              <InvoiceAabFormate invoice={invoice} logo={userData?.logo} />
            ) : (
              <InvoiceGeneralFormat companyName={userData?.name} invoice={invoice} logo={userData?.logo} />
            )}
            <div style={{ height: '80px' }}></div>
            <h4 className="text-center" style={{ fontSize: '16px', fontWeight: '300' }}>
              This is a system generated invoice and does not required any signature and stamp.
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
